export const PAYMENT = {
  HOBEX: 'hobex',
  SEPA: 'sepa'
};

export const TRAVEL_FILTERS = {
  FOREIGN: 0,
  INLAND: 1,
  SINGLE: 0,
  FAMILY: 1
};

export const PAYMENT_RESPONSE = {
  SUCCESS: 'FINISHED',
  REVEIW: 'REVIEW',
  INITIATED: 'INITIATED',
  ERROR: 'ERROR'
};

export const MAX_AGE = 125;

export const countries = {
  AT: 'Österreich'
};

export const GENDER_MALE = 0;
export const GENDER_FEMALE = 1;
